import extractTrigger from "./extract-trigger";

/**
 * Check for the initial step in the offset timeline `0%:` or `0%-0%`
 * @param {String} item
 * @param {Array<String>} result
 */
const prepareInitialSteps = (item, result) => {
  /** Extract data from the string */
  const data = extractTrigger(item);
  const rest = /** @type {String} */ (data.get("rest"));
  const sliced = /** @type {String} */ (rest.slice(1, -1));
  const first = /^(0s_|0s-0s|0%_|0%-0%)/.test(sliced);

  /** If the step is initial one (has `0%:` or `0s`) */
  if (first) {
    const split = sliced?.split("╚")[0];
    const property = split.split("_")[1];
    const pure = property.slice(1, -1);

    item = item.replace(`${split}╚`, "");

    /** Initial property first */
    result.push(`[0s_[${pure}]]`);

    /** Then the rest */
    result.push(item);
  } else {
    /** Is already defined in the right timeline format. Don't process */
    result.push(item);
  }
};

export default prepareInitialSteps;
